module.exports = __webpack_public_path__ + "static/simse-668916ff72141564c6dba06732cfe02b.jpg";